import { getClientCustomFetch } from '../lib/getClientCustomFetch'
import { setData, clearData } from '../lib'

function serializeNested(obj, prefix) {
  const query = []
  for (const key in obj) {
    const value = obj[key]
    const k = prefix ? `${prefix}[${key}]` : key
    if (value && typeof value === 'object') {
      query.push(...serializeNested(value, k))
    } else {
      query.push(`${k}=${encodeURIComponent(value)}`)
    }
  }
  return query
}

const postCart = async (address, items, { accessToken }) => {
  const customFetch = await getClientCustomFetch()
  // here in res we are merging those items quantity whose product id is same in cart
  // else if not then will directly pushing item in res
  const res = {}

  items?.forEach((item) => {
    if (res[item.id]) {
      const val = parseInt(item.q) + parseInt(res[item.id].q)
      res[item.id].q = val.toString()
    } else {
      res[item.id] = item
    }
  })
  try {
    const payload = {
      cart: {
        items: Object.values(res),
      },
      orderType: address.type,
      storeId: `${address?.storeId || address.address?.storeId || ''}`,
    }

    if (address.type === 'PICKUP') {
      payload.pickupLocationId = address.pickupLocationId
    } else if (accessToken && address.address && address.address.id) {
      payload.addressId = address.address.id
    } else {
      payload.address = address.address
    }

    // if (!accessToken) {
    //   const localItems = localCart.items || []
    //   const mergedItems = mergeItems(localItems, items)
    //   payload.cart = { items: mergedItems }
    // }
    const response = await customFetch.post('/cart', payload, {
      headers: { excludeAuth: accessToken ? false : true },
    })
    const cart = response?.data?.cart || {}
    //here we are assigning index to each cart item
    cart.items?.forEach((item, index) => {
      item.uniqueKey = `${item.id}-${index}`
      const bundleType = item?.product?.metaData?.bundleType
      if (bundleType) {
        const matchingItem = payload?.cart?.items?.find(
          (data) => data.id === item.id
        )
        const bundleItems = matchingItem?.bundleItems
        item.bundleItems = bundleItems
      }
    })
    if (!accessToken) setData('cart', JSON.stringify(cart))
    else clearData('cart')
    return cart
  } catch (err) {
    console.error(err)
    return {}
  }
}

const getCart = async (address, { accessToken }) => {
  const customFetch = await getClientCustomFetch()

  const storeId = address?.storeId ?? address?.address?.storeId

  const orderType = address?.type ?? address?.address?.type

  const params = {
    storeId,
    orderType,
  }

  if (orderType === 'PICKUP') {
    const pickupLocationId =
      address?.pickupLocationId ?? address?.eaStoreId ?? storeId

    if (pickupLocationId) {
      params.pickupLocationId = pickupLocationId
    }
  } else {
    const addrObj = address?.address

    if (addrObj?.id) {
      params.addressId = addrObj.id
    } else {
      params.address = addrObj
    }
  }

  const query = serializeNested(params).join('&')

  const response = await customFetch.get(`/cart?${query}`, {
    headers: { excludeAuth: accessToken ? false : true },
  })

  const { cart } = response?.data || {}
  cart?.items?.forEach((item, index) => {
    item.uniqueKey = `${item.id}-${index}`
  })
  return cart
}

export { postCart, getCart }
